import React, { useEffect } from "react"
import { connect } from "react-redux"
import styled from "@emotion/styled"

import PrevButton from "../prevbutton"
import { triggerGlobalUnmount, setShowBackBtn } from "../../actions"

import { queries } from  "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"

const HeaderText = styled(TextElementMen)`
  ${queries.medium`
    font-size: 12px !important;
    line-height: 16px !important;
  `}
`
const PrevButtonWrap = styled.div`
  display: inline-block;
  width: auto;
`

const BackButton = props => {

  const { showBackBtn, setShowBackBtn, quizData } = props

  const {
    currentSection = "basics",
    quizProgress,
    userToken,
    triggerGlobalUnmount,
    currentQuestionId,
  } = props

  useEffect(() => {
    const hideButton = !currentQuestionId ||  (["results"].indexOf(currentQuestionId)>-1)
    //debugger
    setShowBackBtn(!hideButton)
  }, [currentSection, quizProgress, setShowBackBtn, currentQuestionId])

  const introClick = () => {
    if (currentSection === "basics" && quizProgress === 0) {
      setShowBackBtn(false)
    }
  }

  return (
    <>
      {currentSection?.indexOf("results") > -1 ? (
        <HeaderText text={`Quiz Results`} element="p" className="mono--small text-master-secondary-default uppercase" />
      ) : (
        <>
          {showBackBtn ? (
            <PrevButtonWrap onClick={introClick}>
              <PrevButton
                mobileBack={true}
                token={userToken}
                triggerGlobalUnmount={triggerGlobalUnmount}
                quizData={quizData}
              />
            </PrevButtonWrap>
          ) : (
            <HeaderText text={`Hair Health Quiz`} element="p" className="mono--small text-master-secondary-default  uppercase" />
          )}
        </>
      )}
    </>
  )
}

const mapStateToProps = state => {
  return {
    currentSection: state.sectionReducer.currentSection,
    quizProgress: state.progressReducer.quizProgress,
    currentQuestionId: state.questionIdReducer.currentQuestionId,
    showBackBtn: state.progressReducer.showBackBtn,
  }
}

export default connect(mapStateToProps, {
  triggerGlobalUnmount,
  setShowBackBtn,
})(BackButton)
